// Quota banner (Unit 35, spec Step 5, SC-07).
//
// Renders when the paper status is "quota_exceeded". Includes a mailto link
// to Jonas so Kim can flag the issue quickly. Step 5 says the banner stays
// visible until the pipeline finishes again.

import { useTranslation } from "react-i18next";

import "./QuotaBanner.css";

const CONTACT_EMAIL = "stoetzer@magnotherm.com";

export function QuotaBanner({ paperId }: { paperId: number }) {
  const { t } = useTranslation();
  const subject = encodeURIComponent(`ophelia — quota exceeded (paper ${paperId})`);
  return (
    <div className="quota-banner" role="alert">
      <div className="quota-banner__title">{t("paper_review.quota_banner_title")}</div>
      <div className="quota-banner__body">{t("paper_review.quota_banner_body")}</div>
      <a
        className="quota-banner__contact"
        href={`mailto:${CONTACT_EMAIL}?subject=${subject}`}
      >
        {t("paper_review.quota_banner_contact")}
      </a>
    </div>
  );
}
